import get from 'lodash.get';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { SagaIterator } from 'redux-saga';

// Constants
import {
    LOGIN_LOAD_REQUESTED,
    RENEW_ID_TOKEN,
    SIGN_IN_AS_USER
    // @ts-ignore
} from './constants';

// Actions
import {
    loggedIn,
    loggingInError,
    idTokenRenewed,
    idTokenRenewingError
    // @ts-ignore
} from './actions';

// Selectors
// @ts-ignore
import { selectIsOnline } from '../connection/selectors';
// @ts-ignore
import { idTokenSelector } from './selectors';

// Utils
// @ts-ignore
import Auth from '../../utils/Auth';

/**
 * Login request/response handler
 */
export function* postLogin({ payload }: any): SagaIterator {
    try {
        const idToken = yield call(Auth.login, payload);
        yield put(loggedIn(idToken));
    } catch (error) {
        yield put(
            loggingInError({
                message: get(error, 'details.error_description'),
                ...error
            })
        );
    }
}

export function* watchLogin(): SagaIterator {
    yield takeLatest(LOGIN_LOAD_REQUESTED, postLogin);
}

/**
 * RenewIdToken request/response handler
 */
export function* postRenewIdToken(): SagaIterator {
    // ID Token Selector
    const idToken = yield select(idTokenSelector);

    // Select Is Online
    const isOnline = yield select(selectIsOnline);

    if (isOnline) {
        try {
            const newIdToken = yield call(Auth.getDelegationToken, idToken);
            yield put(idTokenRenewed(newIdToken));
        } catch (error) {
            yield put(idTokenRenewingError(error));
        }
    }
}

export function* watchRenewIdToken(): SagaIterator {
    yield takeLatest(RENEW_ID_TOKEN, postRenewIdToken);
}

/**
 * SignInAsUser request/response handler
 */
export function* postSignInAsUser({ payload }: any): SagaIterator {
    try {
        const idToken = yield call(Auth.signInAsUser, payload);
        yield put(loggedIn(idToken));
    } catch (error) {
        yield put(loggingInError(error));
    }
}

export function* watchSignInAsUser(): SagaIterator {
    yield takeLatest(SIGN_IN_AS_USER, postSignInAsUser);
}
